export const fundExplanation = {
  fund_order_closing_time: 'Thời gian quỹ huỷ lệnh (nếu chưa thanh toán)',
  fund_order_time: 'Thời gian Stag gửi lệnh sang quỹ',
  fund_updated_at: 'Thời gian cập nhật cuối từ quỹ',
  fund_purchase_date: 'Thời gian quỹ tạo lệnh',
};
